import { lazyLoad } from 'utils/loadable';

export const ClientContactTaskLoadable = lazyLoad(
  () => import('./ClientContactTask'),
  module => module.ClientContactTask,
);
